'use client';

import './Logo.css';
import Image from 'next/image';

const Logo = () => {
  return (
    <div className="Logo">
      <a href="/" className="Logo">
        <Image
          src="/images/Header/MI_Logo.svg"
          alt="Munich Indians Logo"
          className="logoImg"
          width={177}
          height={40}
          priority
          loading="eager"
        />
      </a>
    </div>
  );
};

export default Logo;
